module.exports = __webpack_public_path__ + "img/叶坪红军烈士纪念塔.6780d01c.png";